var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrelandFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.214286,
    y: 4.14284,
    width: 23.5715,
    height: 16.7143,
    rx: 1.5,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.428572
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2146_48064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 19
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.214286,
    y: 4.14284,
    width: 23.5715,
    height: 16.7143,
    rx: 1.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.428572
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2146_48064)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3.92856,
    width: 8.00001,
    height: 17.1429,
    fill: "#FF8515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 21.0714H8.00001V3.92856H0V21.0714Z",
    fill: "#07BB59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrelandFlag);
export default __webpack_public_path__ + "static/media/ireland-flag.74340e57b8756672647a64ba78fd049e.svg";
export { ForwardRef as ReactComponent };